//import { paymentPage } from './pages/paymentPage/paymentPage';
import { donationInterruptPage } from './pages/donationInterruptPage/donationInterruptPage';
import { profilePage } from './pages/profilePage/profilePage';
import { headerMenu } from './modules/header-menu';
import { aceModal } from './modules/ace-modal';
import { blockClicksOnLoad } from './modules/block-clicks-on-load';
import { showHidePassword } from './modules/show-hide-password';
import { selectPerformance } from './pages/exchangesPage/exchangesPage-selectPerformance';
import { selectTickets } from './pages/exchangesPage/exchangesPage-selectTickets';
import { voucherPage } from './pages/voucherPage/voucherPage';
import CartTimer from './modules/cart-timer';
import { SvgSprite } from './modules/svg-loader';
import { Modal } from './modules/a11y-modal';
import { StateDropdown } from './modules/stateDropdown';

// Extend Window interface to include spritePath
declare global {
    interface Window {
        spritePath?: string;
    }
}

// SVG Sprite Inject
const spriteSVGPath = window.spritePath || '/Static/img/adage-sprite.svg';
new SvgSprite(spriteSVGPath);
new CartTimer();
donationInterruptPage();
profilePage();
headerMenu();
aceModal();
blockClicksOnLoad();
showHidePassword();
selectPerformance();
selectTickets();
voucherPage();

const modals = Array.prototype.slice.call(document.querySelectorAll('[data-modal]')) as HTMLElement[];
modals.forEach(modal => {
    new Modal(modal);
});

const stateDropdown = document.querySelector('#State') as HTMLSelectElement;
const countryDropdown = document.querySelector('#Country') as HTMLSelectElement;
if (stateDropdown && countryDropdown) {
    new StateDropdown(stateDropdown, countryDropdown);
}

//Reset stepper inputs on voucher page when reaching the page via the back button
window.addEventListener('pageshow', () => {
    var stepperInputs = Array.prototype.slice.call(document.querySelectorAll('.stepper-input')) as HTMLInputElement[];
    if (stepperInputs.length > 0) {
        stepperInputs.forEach((i) => {
            i.value = '0';
        })
    }
})